<template>
  <div
    class="content-wrapper"
    :class="[
      `content-wrapper--${ type }`,
      { 'content-wrapper--center': center, 'content-wrapper--top-padding': topPadding }
    ]"
  >
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'normal',
      validator: propValue => ['normal', 'small', 'big', 'huge'].includes(propValue)
    },
    center: {
      type: Boolean,
      default: false
    },
    topPadding: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  .content-wrapper {
    width: 100%;
    margin: 0 auto;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      padding: 60px 0 !important;
    }

    &--normal {
      padding: 0 $container-margin;
      max-width: 480px;
    }

    &--small {
      padding: 0 2.5 * $container-margin;
      max-width: 400px;
      @media screen and (max-height: 480px) {
        padding: 0 20px !important;
      }
    }

    &--big {
      padding: 0 $container-margin;
      max-width: 600px;
    }

    &--huge {
      padding: 0 $container-margin;
      max-width: 980px;
    }

    &--center {
      display: flex;
      justify-content: center;
    }

    &--top-padding {
      padding-top: 32px;

      @include media-up(md) {
        padding-top: 40px;
      }

      @include media-up(lg) {
        padding-top: calc(80px + 7.5vh);
      }
    }

    &:last-child {
      padding-bottom: 40px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ContentWrapper.vue